<template>
    <BaseDialog v-bind="$attrs" v-model:open="open" :title="t('components.workIq.consent.title')" show-close>
        <div class="flex flex-col gap-4 w-full">
            <p class="body-small text-ink-muted">
                {{ t("components.workIq.consent.intro") }}
            </p>
            <ul class="flex flex-col gap-2.5 w-full">
                <li v-for="item in dataItems" :key="item.icon" class="flex flex-row gap-2.5 items-start body-small text-ink">
                    <i :class="item.icon" class="text-ink-muted mt-1" aria-hidden="true"></i>
                    <span>{{ item.label }}</span>
                </li>
            </ul>
            <p class="body-small text-ink-muted">{{ t("components.workIq.consent.disconnectAnytime") }}</p>
        </div>

        <template #footer>
            <BaseButton theme="tertiary" data-test-id="workiq-consent-cancel" @click="closeDialog()">{{ t("common.cancel") }}</BaseButton>
            <BaseButton theme="primary" data-test-id="workiq-consent-continue" @click="confirmConnect()">{{ t("components.workIq.consent.continueToMicrosoft") }}</BaseButton>
        </template>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";
import { logUserInteraction } from "~vue/utils/logUtils";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineOptions({ inheritAttrs: false });

const open = defineModel<boolean>("open");

const emit = defineEmits<{
    confirm: [];
}>();

// Copy is a product/legal call (PLT-1758 open question) — this describes the Microsoft 365 data
// WorkIQ can surface, kept deliberately high level pending review.
const dataItems = computed((): { icon: string; label: string }[] => [
    { icon: "bi bi-envelope", label: t("components.workIq.consent.emails") },
    { icon: "bi bi-calendar2-week", label: t("components.workIq.consent.calendar") },
    { icon: "bi bi-chat-dots", label: t("components.workIq.consent.teamsChats") },
    { icon: "bi bi-files", label: t("components.workIq.consent.documents") },
]);

const closeDialog = () => {
    open.value = false;
};

const confirmConnect = () => {
    logUserInteraction("workiq_integration_consent_accepted");
    open.value = false;
    emit("confirm");
};
</script>
